(function () {
  'use strict';

  function closestControl(target) {
    if (!target) return null;
    if (typeof target.closest === 'function') {
      return target.closest('.cart-close-btn[data-action="close-cart"], .mobile-menu-close[data-action="close-mobile-menu"]');
    }
    return target.parentElement && typeof target.parentElement.closest === 'function'
      ? target.parentElement.closest('.cart-close-btn[data-action="close-cart"], .mobile-menu-close[data-action="close-mobile-menu"]')
      : null;
  }

  function closePanel(event) {
    var control = closestControl(event.target);
    if (!control) return;

    var isCart = control.getAttribute('data-action') === 'close-cart';
    // Keep the menu over the page until the tap completes. Hiding it on
    // pointerdown exposes the announcement beneath the later click.
    if (!isCart && event.type !== 'click') return;
    if (isCart && event.type === 'click') return;

    event.preventDefault();
    event.stopPropagation();

    var panel = document.getElementById(isCart ? 'cartDrawer' : 'mobileMenu');
    var overlay = document.getElementById(isCart ? 'cartOverlay' : 'mobileMenuOverlay');
    if (panel) panel.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';

    var main = document.getElementById('MainContent');
    if (main) main.removeAttribute('inert');

    var returnTarget = document.querySelector(isCart ? '.cart-icon-wrapper' : '#hamburger');
    if (returnTarget) {
      if (!isCart) returnTarget.setAttribute('aria-expanded', 'false');
      returnTarget.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', closePanel, true);

  if (window.PointerEvent) {
    document.addEventListener('pointerdown', closePanel, true);
  } else {
    document.addEventListener('touchstart', closePanel, { capture: true, passive: false });
  }
}());
